import { Link } from "react-router-dom";

export function NavigationItem({ path, icon, alt, tooltip, roles, userRole  }) {
    if (roles && !roles.includes(userRole)) return null;

    return (
      <li className="aside-row">
        <Link to={path}>
          <img src={icon} alt={alt} />
        </Link>
        <div className="tooltip-aside">{tooltip}</div>
      </li>
    );
}